import type { CustomSEOPage } from '@iheartjane/data-access';
import type { Nullish } from '@iheartjane/types';
import { processSeoVariables } from '@iheartjane/utils';

import styles from './seoHeading.module.css';

interface SeoHeadingProps {
  customSEOPage?: Nullish<CustomSEOPage>;
  defaultTitle?: Nullish<string>;
  metaVariables: Record<string, string>;
}

export const SeoHeading = ({
  customSEOPage,
  defaultTitle,
  metaVariables,
}: SeoHeadingProps) => {
  if (!metaVariables['storeName']) return null;

  const title = processSeoVariables(
    customSEOPage?.title ?? defaultTitle,
    metaVariables
  );

  return <h1 className={styles['screenReaderOnly']}>{title}</h1>;
};
